import { createSlice } from '@reduxjs/toolkit';
import Customer from "../models/customer";
import reducers from "./customerReducer"

const initialCustomerState = {
    customer: new Customer(),
    error: {
        isError: false,
        errorObj: {
            message: "",
            operation: "",
            mainItemId: ""
        }
    }
};

const customerSlice = createSlice({
    name: 'Customer',
    initialState: initialCustomerState,
    reducers: reducers
});

export default customerSlice;
